export function normalizeDecimalText(raw) {
    const text = raw === null || raw === undefined ? "" : String(raw);
    const unified = text.replace(/[,:·]/g, ".").replace(/[^\d.]/g, "");
    const [whole, ...rest] = unified.split(".");
    return rest.length > 0 ? `${whole || "0"}.${rest.join("")}` : whole;
}

export function normalizeIntegerText(raw) {
    const text = raw === null || raw === undefined ? "" : String(raw);
    return text.split(/[.,:·]/)[0].replace(/\D/g, "");
}

function applyNormalized(event, normalize) {
    const normalized = normalize(event.target.value);
    if (event.target.value !== normalized) {
        event.target.value = normalized;
    }
    return normalized;
}

export function applyDecimalInput(event) {
    return applyNormalized(event, normalizeDecimalText);
}

export function applyIntegerInput(event) {
    return applyNormalized(event, normalizeIntegerText);
}
